import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router, Switch,Route} from "react-router-dom";
import Home from './pages/home/index';
import Activity from './pages/activity/activity';
import Case from "./pages/case/case"
import Information from "./pages/information/information"
import InformationDetail from "./pages/informationDetail/informationDetail"
import Teachers from "./pages/teachers/teachers"
import Empty from "./pages/empty/empty"
import Uk from "./pages/uk/uk"
import Australia from "./pages/australia/australia"
import Newzealand from "./pages/newzealand/newzealand"
import Europe from "./pages/europe/europe"
import Canada from "./pages/canada/canada"
import Singapore from "./pages/singapore/singapore"
import Hongkong from "./pages/hongkong/hongkong"
import Korea from "./pages/korea/korea"
import Malaysia from "./pages/malaysia/malaysia"
import Japan from "./pages/japan/japan"
import AboutUs from "./pages/aboutus/aboutus"
import Usmeiyan from "./pages/us-meiyan/usmeiyan"
import Usmeiben from "./pages/us-meiben/usmeiben"
import Process from "./pages/process/process"
import ActivityDetail from "./pages/activityDetail/activityDetail"
import Usa from "./pages/usa/usa"
import ScrollToTop from "./pages/components/ScrollToTop"
ReactDOM.render(
  <Router>
	  <ScrollToTop>
		  <Switch>
			  <Route exact path="/" component={Home}/>
			  <Route path='/activity' component={Activity} />
			  <Route path='/activitydetail/:id' component={ActivityDetail} />
			  <Route path='/case' component={Case} />
			  <Route path='/information' component={Information} />
			  <Route path='/informationdetail/:id' component={InformationDetail} />
			  <Route path='/teachers' component={Teachers} />
			  <Route path='/uk' component={Uk} />
			  <Route path='/australia' component={Australia} />
			  <Route path='/newzealand' component={Newzealand} />
			  <Route path='/europe' component={Europe} />
			  <Route path='/canada' component={Canada} />
			  <Route path='/singapore' component={Singapore} />
			  <Route path='/hongkong' component={Hongkong} />
			  <Route path='/Korea' component={Korea} />
			  <Route path='/malaysia' component={Malaysia} />
			  <Route path='/japan' component={Japan} />
			  <Route path='/aboutus' component={AboutUs} />
			  <Route path='/usmeiyan' component={Usmeiyan} />
			  <Route path='/usmeiben' component={Usmeiben} />
			  <Route path='/process' component={Process} />
			  <Route path='/usa' component={Usa} />
			  <Route path='/*' component={Empty} />
		  </Switch>
	  </ScrollToTop>
  </Router>
  ,document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
